





























































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  BibliographyDetailAuthority,
  FirstMarcLabel,
  GetSystemCodeRequest,
  MarcTag,
  SystemCode,
  systemCodeApi
} from '@/api'
import { cloneDeep } from 'lodash'
import { BibliographyTagData } from '@/api/models'
import {
  TagAuthorityAuthorDisplay,
  TagAuthorityAuthorKana,
  TagAuthorityCompleteWorksDisplay,
  TagAuthorityCompleteWorksKana,
  TagAuthorityPublisherDisplay,
  TagAuthorityPublisherKana,
  TagAuthoritySeriesDisplay,
  TagAuthoritySeriesKana,
  TagAuthoritySubjectDisplay,
  TagAuthoritySubjectKana
} from '@/types'
import CODE_KEY from '@/config/code_key'

interface MarcTagItem {
  tag: string
  labelName: string
  repeat: boolean
  fieldType: string
  maxLength: number
  systemCodeKey: string
  no: string
  data: string
}

interface MarcTagInput {
  tag: string
  marcTag: string
  labelName: string
  repeat: boolean
  fieldType: string
  maxLength: number
  systemCodeKey: string
  no: string
  data: string
  errorMessage: string
}

interface MarcLabelInput {
  labelName: string
  repeat: boolean
  tags: MarcTagInput[]
  no: string
}

interface FirstMarcLabelInput extends MarcLabelInput {
  secondMarcLabels: MarcLabelInput[]
}

interface MarcLabelItem {
  labelName: string
  repeat: boolean
  tags: MarcTagItem[]
  no: string
}

interface NavItem {
  text: string
  key: string | number
}

interface firstMarcLabelItem extends MarcLabelItem {
  secondMarcLabels: MarcLabelItem[]
}

@Component({
  components: {}
})
export default class BibliographyTagDataList extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  details!: BibliographyTagData[]

  @Prop({
    type: Array,
    required: true
  })
  authorities!: BibliographyDetailAuthority[]

  @Prop({
    type: Array,
    required: true
  })
  firstMarcLabels!: FirstMarcLabel[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    required: true
  })
  showNav!: number

  activeTab: number = 0

  navItems: NavItem[] = [
    {
      text: 'すべて表示',
      key: 'all'
    },
    {
      text: '簡易表示',
      key: 'simple'
    },
    {
      text: '管理情報',
      key: 1
    },
    {
      text: 'タイトル・責任表示',
      key: 2
    },
    {
      text: '出版',
      key: 3
    },
    {
      text: '件名',
      key: 4
    },
    {
      text: '注記',
      key: 5
    },
    {
      text: '目次',
      key: 6
    },
    {
      text: 'その他',
      key: 7
    }
  ]

  systemCodes: SystemCode[] = []

  created() {
    this.fetchCodeKey()
  }

  async fetchCodeKey() {
    const codeKeys: string[] = [
      CODE_KEY.MARC_TYPE.KEY,
      CODE_KEY.CARD_TYPE.KEY,
      CODE_KEY.LANGUAGE.KEY,
      CODE_KEY.GENERAL_TYPE.KEY,
      CODE_KEY.SPECIFIC_TYPE.KEY,
      CODE_KEY.BIBLIOGRAPHY_UNIT.KEY,
      CODE_KEY.CONTINUATION_STATUS_FLAG.KEY,
      CODE_KEY.JAPANESE_AND_WESTERN_TYPE.KEY,
      CODE_KEY.PUBLICATION_IDENTIFIER.KEY,
      CODE_KEY.MATERIAL_FORMAT.KEY,
      CODE_KEY.PUBLICATION_FREQUENCY.KEY,
      CODE_KEY.OPAC_PUBLIC_AVAILABILITY.KEY
    ]

    const systemCodeRequest: GetSystemCodeRequest = {
      codeKey: '',
      codeKeys,
      code: ''
    }

    this.systemCodes = await systemCodeApi.getSystemCodes(systemCodeRequest)
  }

  get firstMarcLabelItems() {
    const details = cloneDeep(this.details)

    const firstMarcLabelInputs: FirstMarcLabelInput[] = []

    for (let i = 0; i < this.firstMarcLabels.length; i++) {
      const firstLabel = this.firstMarcLabels[i]

      const navItem = this.navItems[this.activeTab]
      if (navItem.key === 'simple') {
        if (!firstLabel.tabSimple) continue
      }

      if (typeof navItem.key === 'number') {
        if (firstLabel.tabPage !== navItem.key) continue
      }

      // 上位番号取得
      const topNumbers: string[] = []

      let topNumberReg
      if (firstLabel.tagGroup === 'E0') {
        // フリーワードだけ第一階層の連番が中位番号のため、中位番号から連番を取得
        topNumberReg = new RegExp(`^E00001[0-9n]{2}([0-9]{4})[0-9n]{6}$`)
      } else {
        topNumberReg = new RegExp(
          `^${firstLabel.tagGroup}([0-9]{4})[0-9n]{12}$`
        )
      }
      for (let j = 0; j < details.length; j++) {
        const detail = details[j]
        const matchTag = detail.tag.match(topNumberReg)

        if (matchTag !== null) {
          if (!topNumbers.includes(matchTag[1])) {
            topNumbers.push(matchTag[1])
          }
        }
      }

      // ラベルインデックスが必ず1から始まるようにする
      topNumbers.sort()

      topNumbers.forEach(nextNumber => {
        const firstMarcLabelItem: FirstMarcLabelInput = {
          labelName: firstLabel.labelName,
          repeat: firstLabel.repeat,
          tags: [],
          no: nextNumber,
          secondMarcLabels: []
        }

        // 第1階層tagデータ算出
        for (let t = 0; t < firstLabel.tags.length; t++) {
          const tagItem = firstLabel.tags[t]

          // tag番号取得
          const tagReg = new RegExp(
            '^([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}$'
          )
          const tags = tagItem.tag.match(tagReg)
          if (tags == null) {
            continue
          }

          // 上中下番号取得
          const numberTagReg = new RegExp(
            '^[0-9A-Z]{2}([0-9n]{4})[0-9A-Z]{2}([0-9n]{4})[0-9A-Z]{2}([0-9n]{4})$'
          )
          const numberTag = tagItem.tag.match(numberTagReg)
          if (numberTag === null) {
            continue
          }

          // MARC番号、カード番号、その他番号は区分表示時に処理するため何もしない
          if (this.isNumberTag(tagItem.tag)) {
            continue
          }

          // 役割区分は典拠表記表示時に処理するため何もしない
          if (this.isRoleTag(tagItem.tag)) {
            continue
          }

          const topNumber = numberTag[1] === '0001' ? '0001' : nextNumber
          const middleNumber = numberTag[1] === '0001' ? nextNumber : '0001'

          // 下位番号取得
          const bottomNumberRegValue =
            numberTag[3] === 'nnnn' ? '[0-9n]{4}' : numberTag[3]
          const bottomNumberReg = new RegExp(
            `^${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}(${bottomNumberRegValue})$`
          )

          for (let j = 0; j < details.length; j++) {
            const detail = details[j]
            const matchTag = detail.tag.match(bottomNumberReg)

            if (matchTag !== null) {
              const bottomNumber = matchTag[1]
              const tag = `${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}${bottomNumber}`

              // MARC区分・番号
              if (this.isNumberTypeTag(tagItem.tag)) {
                const numberTagItems = this.createNumberTag(
                  tag,
                  tagItem,
                  detail.data,
                  bottomNumber
                )
                firstMarcLabelItem.tags.push(...numberTagItems)
                continue
              }

              // 典拠
              if (tagItem.fieldType.startsWith('authority_')) {
                const authorityTagItems = this.createAuthorityTag(
                  tag,
                  tagItem,
                  `${tags[1]}${topNumber}${tags[2]}${middleNumber}04${bottomNumber}`,
                  detail.data,
                  bottomNumber
                )

                firstMarcLabelItem.tags.push(...authorityTagItems)
                continue
              }

              // システムコード
              if (tagItem.fieldType === 'system_code') {
                const numberTagItems = this.createSystemCodeTag(
                  tag,
                  tagItem,
                  detail.data,
                  bottomNumber
                )
                firstMarcLabelItem.tags.push(...numberTagItems)
                continue
              }

              const marcTagData: MarcTagInput = {
                tag,
                marcTag: tagItem.tag,
                labelName: tagItem.labelName,
                repeat: tagItem.repeat,
                fieldType: tagItem.fieldType,
                maxLength: tagItem.maxLength,
                systemCodeKey: tagItem.systemCodeKey,
                no: bottomNumber,
                data: detail.data,
                errorMessage: ''
              }
              firstMarcLabelItem.tags.push(marcTagData)
            }
          }
        }

        // 第2階層ラベルデータ算出
        firstMarcLabelItem.secondMarcLabels = this.createSecondLabelInput(
          firstLabel,
          details,
          nextNumber
        )

        if (
          firstMarcLabelItem.tags.length > 0 ||
          firstMarcLabelItem.secondMarcLabels.length > 0
        ) {
          firstMarcLabelInputs.push(firstMarcLabelItem)
        }
      })
    }

    return firstMarcLabelInputs
  }

  createSecondLabelInput(
    firstLabel: FirstMarcLabel,
    details: BibliographyTagData[],
    topNumber: string
  ) {
    const secondMarcLabelItems: MarcLabelInput[] = []

    for (let i = 0; i < firstLabel.secondMarcLabels.length; i++) {
      const secondLabel = firstLabel.secondMarcLabels[i]

      // 中位番号取得
      const middleNumbers: string[] = []
      for (let j = 0; j < secondLabel.tags.length; j++) {
        const tagItem = secondLabel.tags[j]

        // tag番号取得
        const tagReg = new RegExp(
          '^([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}$'
        )
        const tags = tagItem.tag.match(tagReg)
        if (tags === null) {
          continue
        }

        // 中位tag番号取得
        const middleNumberReg = new RegExp(
          `^${tags[1]}${topNumber}${tags[2]}([0-9]{4})${tags[3]}[0-9]{4}$`
        )
        for (let j = 0; j < details.length; j++) {
          const detail = details[j]
          const matchTag = detail.tag.match(middleNumberReg)

          if (matchTag !== null) {
            if (!middleNumbers.includes(matchTag[1])) {
              middleNumbers.push(matchTag[1])
            }
          }
        }
      }

      // ラベルインデックスが必ず1から始まるようにする
      middleNumbers.sort()

      middleNumbers.forEach(middleNumber => {
        const secondMarcLabelItem: MarcLabelInput = {
          labelName: secondLabel.labelName,
          repeat: secondLabel.repeat,
          tags: [],
          no: middleNumber
        }

        // 第2階層tagデータ算出
        for (let t = 0; t < secondLabel.tags.length; t++) {
          const tagItem = secondLabel.tags[t]

          // tag番号取得
          const tagReg = new RegExp(
            '^([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}$'
          )
          const tags = tagItem.tag.match(tagReg)
          if (tags === null) {
            continue
          }

          // MARC番号、カード番号、その他番号は区分表示時に処理するため何もしない
          if (this.isNumberTag(tagItem.tag)) {
            continue
          }

          // 役割区分は典拠表記表示時に処理するため何もしない
          if (this.isRoleTag(tagItem.tag)) {
            continue
          }

          // 下位番号取得
          const bottomNumberWithN = tagItem.tag.substr(-4, 4)
          const bottomNumberRegValue =
            bottomNumberWithN === 'nnnn' ? '[0-9n]{4}' : bottomNumberWithN
          const bottomNumberReg = new RegExp(
            `^${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}(${bottomNumberRegValue})$`
          )

          for (let j = 0; j < details.length; j++) {
            const detail = details[j]
            const matchTag = detail.tag.match(bottomNumberReg)

            if (matchTag !== null) {
              const bottomNumber = matchTag[1]
              const tag = `${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}${bottomNumber}`

              // MARC区分・番号
              if (this.isNumberTypeTag(tagItem.tag)) {
                const numberTagItems = this.createNumberTag(
                  tag,
                  tagItem,
                  detail.data,
                  bottomNumber
                )
                secondMarcLabelItem.tags.push(...numberTagItems)
                continue
              }

              // 典拠
              if (tagItem.fieldType.startsWith('authority_')) {
                const authorityTagItems = this.createAuthorityTag(
                  tag,
                  tagItem,
                  `${tags[1]}${topNumber}${tags[2]}${middleNumber}04${bottomNumber}`,
                  detail.data,
                  bottomNumber
                )

                secondMarcLabelItem.tags.push(...authorityTagItems)
                continue
              }

              // システムコード
              if (tagItem.fieldType === 'system_code') {
                const numberTagItems = this.createSystemCodeTag(
                  tag,
                  tagItem,
                  detail.data,
                  bottomNumber
                )
                secondMarcLabelItem.tags.push(...numberTagItems)
                continue
              }

              const marcTagData: MarcTagInput = {
                tag, // + ' -> ' + detail.tag,
                marcTag: tagItem.tag,
                labelName: tagItem.labelName,
                repeat: tagItem.repeat,
                fieldType: tagItem.fieldType,
                maxLength: tagItem.maxLength,
                systemCodeKey: tagItem.systemCodeKey,
                no: bottomNumber,
                data: detail.data,
                errorMessage: ''
              }
              secondMarcLabelItem.tags.push(marcTagData)
            }
          }
        }

        if (secondMarcLabelItem.tags.length > 0) {
          secondMarcLabelItems.push(secondMarcLabelItem)
        }
      })
    }

    return secondMarcLabelItems
  }

  createNumberTag(
    tag: string,
    tagItem: MarcTag,
    type: string,
    bottomNumber: string
  ) {
    const marcTagInputs: MarcTagInput[] = []

    const marcNumberItem = this.details.find(item => {
      return item.tag === `${tagItem.tag.substr(0, 12)}02${bottomNumber}`
    })
    const marcNumber = marcNumberItem ? marcNumberItem.data : ''

    const marcTagData: MarcTagInput = {
      tag, // + ' -> ' + detail.tag,
      marcTag: tagItem.tag,
      labelName: tagItem.labelName,
      repeat: tagItem.repeat,
      fieldType: tagItem.fieldType,
      maxLength: tagItem.maxLength,
      systemCodeKey: tagItem.systemCodeKey,
      no: bottomNumber,
      data: type + ' ' + marcNumber,
      errorMessage: ''
    }
    marcTagInputs.push(marcTagData)

    return marcTagInputs
  }

  createAuthorityTag(
    tag: string,
    tagItem: MarcTag,
    roleTag: string,
    authorityId: string,
    bottomNumber: string
  ) {
    const marcTagInputs: MarcTagInput[] = []
    // 役割区分
    const roleData = this.details.find(item => {
      return item.tag === roleTag
    })
    const roleName = roleData ? roleData.data : ''

    // 表記
    const authorityNameItem = this.authorities.find(authority => {
      return (
        authorityId === authority.authorityNo &&
        authority.authorityTag ===
          this.getAuthorityDisplayTag(tagItem.fieldType)
      )
    })
    if (authorityNameItem) {
      const marcTagData: MarcTagInput = {
        tag, // + ' -> ' + detail.tag,
        marcTag: tagItem.tag,
        labelName: '表記',
        repeat: tagItem.repeat,
        fieldType: tagItem.fieldType,
        maxLength: tagItem.maxLength,
        systemCodeKey: tagItem.systemCodeKey,
        no: bottomNumber,
        data: authorityNameItem.data + ' ' + roleName,
        errorMessage: ''
      }
      marcTagInputs.push(marcTagData)
    }

    // カナ
    const authorityKanaItem = this.authorities.find(authority => {
      return (
        authorityId === authority.authorityNo &&
        authority.authorityTag === this.getAuthorityKanaTag(tagItem.fieldType)
      )
    })
    if (authorityKanaItem) {
      const marcTagData: MarcTagInput = {
        tag, // + ' -> ' + detail.tag,
        marcTag: tagItem.tag,
        labelName: 'カナ',
        repeat: tagItem.repeat,
        fieldType: tagItem.fieldType,
        maxLength: tagItem.maxLength,
        systemCodeKey: tagItem.systemCodeKey,
        no: bottomNumber,
        data: authorityKanaItem.data,
        errorMessage: ''
      }
      marcTagInputs.push(marcTagData)
    }

    return marcTagInputs
  }

  createSystemCodeTag(
    tag: string,
    tagItem: MarcTag,
    code: string,
    bottomNumber: string
  ) {
    const marcTagInputs: MarcTagInput[] = []

    const systemCode = this.systemCodes.find(systemCode => {
      return (
        systemCode.codeKey === tagItem.systemCodeKey && systemCode.code === code
      )
    })
    const shortName = systemCode ? systemCode.shortName : ''

    const marcTagData: MarcTagInput = {
      tag, // + ' -> ' + detail.tag,
      marcTag: tagItem.tag,
      labelName: tagItem.labelName,
      repeat: tagItem.repeat,
      fieldType: tagItem.fieldType,
      maxLength: tagItem.maxLength,
      systemCodeKey: tagItem.systemCodeKey,
      no: bottomNumber,
      data: shortName,
      errorMessage: ''
    }
    marcTagInputs.push(marcTagData)

    return marcTagInputs
  }

  // MARC・番号区分
  isNumberTypeTag(tag: string) {
    return (
      tag.startsWith('00000112000101nnnn') ||
      tag.startsWith('00000119000101nnnn') ||
      tag.startsWith('00000120000101nnnn')
    )
  }

  // MARC番号、カード番号、その他番号
  isNumberTag(tag: string) {
    return (
      tag.startsWith('00000112000102nnnn') ||
      tag.startsWith('00000119000102nnnn') ||
      tag.startsWith('00000120000102nnnn')
    )
  }

  isRoleTag(tag: string) {
    return (
      tag === '10nnnn05nnnn040001' ||
      tag === '12nnnn05nnnn040001' ||
      tag === '50nnnn05nnnn040001' ||
      tag === '60nnnn05nnnn040001'
    )
  }

  getAuthorityDisplayTag(tag: string) {
    switch (tag) {
      case 'authority_author_no':
        return TagAuthorityAuthorDisplay
      case 'authority_publisher_no':
        return TagAuthorityPublisherDisplay
      case 'authority_subject_no':
        return TagAuthoritySubjectDisplay
      case 'authority_series_no':
        return TagAuthoritySeriesDisplay
      case 'authority_complete_works_no':
        return TagAuthorityCompleteWorksDisplay
    }
    console.error('getAuthorityDisplayTag 未定義：', tag)

    return ''
  }

  getAuthorityKanaTag(tag: string) {
    switch (tag) {
      case 'authority_author_no':
        return TagAuthorityAuthorKana
      case 'authority_publisher_no':
        return TagAuthorityPublisherKana
      case 'authority_subject_no':
        return TagAuthoritySubjectKana
      case 'authority_series_no':
        return TagAuthoritySeriesKana
      case 'authority_complete_works_no':
        return TagAuthorityCompleteWorksKana
    }
    console.error('getAuthorityKanaTag 未定義：', tag)

    return ''
  }
}
